/**
 * Detects critical field changes between old and new event data.
 * Used to warn producers when editing published events with bookings.
 */

const CRITICAL_FIELDS = [
  'start_date',
  'end_date',
  'use_producer_address',
  'custom_address',
  'booking_mode',
  'max_spots',
] as const;

const FIELD_LABELS: Record<string, string> = {
  start_date: 'Starttid',
  end_date: 'Sluttid',
  use_producer_address: 'Plats',
  custom_address: 'Adress',
  booking_mode: 'Bokningsläge',
  max_spots: 'Max antal platser',
};

export function getCriticalChanges(
  oldEvent: Record<string, unknown>,
  newEvent: Record<string, unknown>,
): string[] {
  const changed: string[] = [];

  for (const field of CRITICAL_FIELDS) {
    const oldVal = oldEvent[field] ?? null;
    const newVal = newEvent[field] ?? null;

    if (String(oldVal) !== String(newVal)) {
      changed.push(field);
    }
  }

  return changed;
}

export function getCriticalChangeLabels(fields: string[]): string[] {
  return fields.map((f) => FIELD_LABELS[f] || f);
}
